import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NotificationState } from './notification.state';
import { NotificationService } from './notification.service';

@NgModule({
    imports: [NgxsModule.forFeature([NotificationState])],
    providers: [NotificationService],
})
export class NotificationModule {}
